import { render, staticRenderFns } from "./CustomerScreen.vue?vue&type=template&id=62d55041&scoped=true&"
import script from "./CustomerScreen.vue?vue&type=script&lang=ts&"
export * from "./CustomerScreen.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerScreen.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerScreen.vue?vue&type=style&index=1&id=62d55041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d55041",
  null
  
)

export default component.exports